<script setup>
import { ref } from 'vue'
import { Collapse, CollapseItem } from 'vant'
import RecordList from './RecordList.vue'

const props = defineProps({
  formTree: {
    type: Object,
    default: () => {},
  },
  formDate: Object,
})

const recordType = ref(0)
</script>
<template>
  <!-- tab切换 -->
  <van-tabs
    class="record-tab"
    v-model:active="recordType"
    color="#087EFB"
    title-active-color="#087EFB"
  >
    <van-tab title="全部" :name="0"></van-tab>
    <van-tab title="已填" :name="1"></van-tab>
    <van-tab title="未填" :name="2"></van-tab>
  </van-tabs>
  <RecordList
    :formTree="formTree"
    :recordType="recordType"
    :formDate="formDate"
  />
</template>
<style scoped lang="scss">
.record-tab {
  ::v-deep {
    .van-tab {
      font-size: 17px;
    }
  }
}
</style>
